export const SET_FORM_SUBMISSION = "SET_FORM_SUBMISSION";
export const SET_FORM_SUBMISSION_OK = "SET_FORM_SUBMISSION_OK";
export const SET_FORM_SUBMISSION_ERROR = "SET_FORM_SUBMISSION_ERROR";
export const RESET_FORM_SUBMISSION = "RESET_FORM_SUBMISSION";

export const SAGA_CREATE_DRIVE = "SAGA/CREATE_DRIVE";
export const SAGA_EDIT_DRIVE = "SAGA/EDIT_DRIVE";
